import mrqalogo from '../assets/mqra.png';

const ScreenSize = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif',
            fontSize: '1.5rem',
            color: '#333',
            backgroundColor: '#f9f9f9',
            padding: '2rem',
        }}>
            <div style={{ marginTop: '10vh' }}>
                <strong>Uh-oh!</strong> This app runs best on mobile. <br />
                Time to shrink that screen or switch devices. <br />
                <span style={{ color: '#d32f2f', fontSize: "18px" }}>
                    For the best experience, please view this on your mobile device.
                </span>
            </div>
            <div style={{
                width: '100vw',
                height: '5vh'
            }} ></div>
            <div className="mqralogo" href="http://samudaya.ettarracoffee.com/" style={{ fontSize: '20px', lineHeight: '25px', fontWeight: 300, width: '80vw', textAlign: 'right', letterSpacing: '-5px' }}>&#45;&#45;&#45;&#45;&#45;&#45;&#45;
                <img src={mrqalogo} alt="Menu QR Ate" style={{ margin: '0px 15px' }} />
            </div>
        </div>
    );
};

export default ScreenSize;
